import { useRecipe } from '../context'

type DietaryClaims = 'dairy_free' | 'vegan' | 'vegetarian' | 'gluten_free'
const streamlinedDietaryClaims = ['dairy_free', 'vegan', 'vegetarian', 'gluten_free']

function convertDashToUnderscore(string: string): string {
  return string.replace(/-/g, '_')
}

export const useDietaryClaims = (): DietaryClaims[] | null => {
  const recipe = useRecipe()

  if (!recipe || !recipe.dietaryClaims) {
    return null
  }

  return recipe.dietaryClaims
    .map((claim) => convertDashToUnderscore(claim.slug))
    .filter((claim) => streamlinedDietaryClaims.includes(claim)) as DietaryClaims[] | null
}
